import React, { useState, useEffect } from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { required } from "redux-form-validators";
import { renderField, renderselect, renderselectapi } from "../../../../Components/Forms/renders";
import mask from "../../../../Components/Forms/mask";
import MultiSelectData from "../../../../Components/Forms/multiselectdata";
import AutocompleteLocations from "../../../../Components/Forms/autocomplete-locations";

const ORG_ROLES = new Set(["locatiebeheerder", "medewerker", "event_manager"]);

const GebruikersInsertForm = ({ handleSubmit, bedrijven, initialValues, ervaringen, userorganisaties }) => {
  const [openervaring, setOpenervaring] = useState(false);
  const [showRestrictedLocation, setShowRestrictedLocation] = useState(false);
  const [showOrgs, setShowOrgs] = useState(false);

  const checkrole = (val) => {
    changerole(val.target.value);
  };

  const changerole = (val) => {
    if (val === "manager" || val === "admin" || val === "readonly" || val === "hoofdrecreatie" || val === "havenmeester") {
      setShowRestrictedLocation(false);
      setOpenervaring(false);
    } else if (val === "ervaringeigenaar") {
      setOpenervaring(true);
      setShowRestrictedLocation(false);
    } else if (val === "medewerker") {
      // Medewerker (algemeen) - optioneel gekoppeld aan locatie
      setOpenervaring(false);
      setShowRestrictedLocation(true);
    } else if (val === "locatiebeheerder") {
      // Locatiebeheerder - VERPLICHT gekoppeld aan locatie
      setOpenervaring(false);
      setShowRestrictedLocation(true);
    } else if (val === "event_manager") {
      setOpenervaring(false);
      setShowRestrictedLocation(true);
    } else {
      setShowRestrictedLocation(false);
      setOpenervaring(false);
    }
    setShowOrgs(ORG_ROLES.has(val));
  };

  return (
    <div className="box box-default">
      <form onSubmit={handleSubmit}>
        <div className="box-body">
          <div className="row">
            <div className="col-12">
              <Field name="email" type="input" validate={[required()]} component={renderField} label="Vul het e-mailadres in" />
              <Field name="voornaam" type="input" validate={[required()]} component={renderField} label="Vul de voornaam in" />
              <Field name="achternaam" type="input" validate={[required()]} component={renderField} label="Vul de achternaam in" />
              <Field name="password" type="password" validate={[required()]} component={renderField} autocomplete="on" label="Kies een wachtwoord" />
              <Field name="telefoonnummer" type="input" mask="39999999999" validate={[required()]} component={mask} label="Vul je telefoonnummer in" />
              <Field name="bedrijf" type="input" validate={[required()]} component={renderselectapi} options={bedrijven} label="Vul het bedrijf in" />
              <Field
                name="role"
                type="input"
                validate={[required()]}
                component={renderselect}
                onChange={checkrole}
               options={{
                  admin: "Administrator",
                  manager: "Manager",
                  medewerker: "Medewerker (Algemeen)",
                  locatiebeheerder: "Locatiebeheerder (aan locatie gekoppeld)",
                  ervaringeigenaar: "Ervaringseigenaar",
                  readonly: "Alleen lezen",
                }}
                label="Selecteer de rol van de gebruiker"
              />
              {openervaring && <Field name="ervaringen" type="input" dataKey="_id" textField="naam" validate={[required()]} component={MultiSelectData} options={ervaringen} label="Vul het de ervaringen in" />}
              {showRestrictedLocation && (
                <Field
                  name="restricedLocation"
                  component={AutocompleteLocations}
                  label="(Legacy) Locatiebeheerder: Selecteer één locatie waar deze medewerker events mag beheren"
                />
              )}
              {showOrgs && (
                <Field
                  name="userOrganisaties"
                  type="input"
                  dataKey="_id"
                  textField="naam"
                  component={MultiSelectData}
                  options={userorganisaties || []}
                  label="Koppel aan organisatie(s) (UserOrganisaties)"
                />
              )}
            </div>
          </div>
          <div className="pull-left submit">
            <input type="submit" className="btn btn-next btn-fill btn-success btn-wd btn-mg" name="next" value="Updates" />
          </div>
        </div>
      </form>
    </div>
  );
};

const GebruikersForm = reduxForm({
  form: "gebruikers_insert", // a unique identifier for this form
})(GebruikersInsertForm);

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(GebruikersForm);
